import { useAuth } from '../../auth-lib';
import EmployeeLayout from '../components/EmployeeLayout';
import SecurityPanel from '../../components/SecurityPanel';
import { Card, StatusPill, EmptyState } from '../../design-system';
import '../styles/Employee.css';

function EmployeeProfile() {
  const { user } = useAuth();

  const fields = [
    { label: 'Name', value: user?.name },
    { label: 'Email', value: user?.email },
    { label: 'Phone', value: user?.phone },
    { label: 'Role', value: user?.role?.name },
    {
      label: 'Member since',
      value: user?.createdAt ? new Date(user.createdAt).toLocaleDateString() : null,
    },
  ];

  return (
    <EmployeeLayout title="My Profile" subtitle="Your account and access">
      <div className="employee-page">
        <Card className="employee-section">
          <Card.Header title="Account" />
          <div className="employee-profile-grid">
            {fields.map((f) => (
              <div key={f.label} className="employee-profile-item">
                <span className="employee-profile-label">{f.label}</span>
                <span className="employee-profile-value">{f.value || '—'}</span>
              </div>
            ))}
          </div>
        </Card>

        <Card className="employee-section">
          <Card.Header
            title="My Permissions"
            subtitle="What your role lets you do — set by your firm's admin"
          />
          {user?.permissions?.length ? (
            <div className="employee-permission-list">
              {user.permissions.map((key) => (
                <StatusPill key={key} variant="neutral" label={key} />
              ))}
            </div>
          ) : (
            <EmptyState icon="🔒" title="No explicit permissions" description="Your access comes from your role level." />
          )}
        </Card>

        <SecurityPanel />
      </div>
    </EmployeeLayout>
  );
}

export default EmployeeProfile;
